/* sts-brand-page.js — the brand landing (sections/sts-brand-page.liquid).
   Loaded only by that section. Three jobs, all small (3 is below 1):

   1. Brand video (V6-9.2). The poster is a real link to the video, so it works
      with no script at all; a plain click swaps it for the player instead, so
      no YouTube or Vimeo code loads until someone asks for it. A modified click
      (new tab, new window) is left to the browser.

   2. QA preview of the banner (HD-8). The three banner fields live on the
      sts_brand metaobject, which QA cannot edit, so on an UNPUBLISHED theme only
      (preview links, the review theme) these query parameters restyle the hero:
        ?sts_bb_color=F4E6C8        hex, 3 or 6 digits, with or without #
        &sts_bb_texture=linen       none | dots | diagonal | grain | linen | glow
        &sts_bb_font=playfair       poppins | playfair | dmserif | montserrat | cormorant
      It runs the same rules the server does (WCAG luminance > 0.45 -> dark ink;
      the font on the H1 only, subset to the brand name), changes nothing but
      this page's classes, stores nothing and sends nothing. On the published
      theme (Shopify.theme.role === "main") it does nothing at all, and it never
      runs without one of those parameters. The hero gets data-sts-preview="1"
      so a screenshot shows the override was applied. */
(function (w, d) {
  'use strict';

  d.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-sts-bvideo]') : null;
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var src = a.getAttribute('data-embed');
    if (!src) return;
    e.preventDefault();
    var f = d.createElement('iframe');
    f.className = 'sts-bp__vframe';
    f.src = src;
    f.title = a.getAttribute('data-title') || 'Video';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    f.setAttribute('allowfullscreen', '');
    a.parentNode.replaceChild(f, a);
    f.focus();
  });

  /* 3. v6.1 1.1 "Show products" (Q+): this brand in the shop with the Right
     for you filter on. The filter value is the type code, which only the
     browser knows for a guest, so data-bp-fit is the URL with {type}; a
     signed-in customer's href is already complete. Re-run on every state
     change, so the staff simulator gets it too. */
  if (w.STS && w.STS.onState) w.STS.onState(function (s) {
    if (!s || !s.type) return;
    [].forEach.call(d.querySelectorAll('[data-bp-fit]'), function (a) {
      a.href = a.getAttribute('data-bp-fit').replace('{type}', encodeURIComponent(s.type));
    });
  });

  var theme = w.Shopify && w.Shopify.theme;
  if (!theme || !theme.role || theme.role === 'main' || !w.location.search) return;
  var q;
  try { q = new URLSearchParams(w.location.search); } catch (err) { return; }
  var color = q.get('sts_bb_color'), tx = q.get('sts_bb_texture'), font = q.get('sts_bb_font');
  if (!color && !tx && !font) return;

  function run() {
    var hero = d.querySelector('[data-sts-bhero]');
    if (!hero) return;
    var h1 = hero.querySelector('.sts-bhero__h1');
    var applied = {};

    if (color) {
      var h = String(color).replace(/^#/, '').toLowerCase();
      if (/^[0-9a-f]{3}$/.test(h)) h = h.replace(/(.)/g, '$1$1');
      if (/^[0-9a-f]{6}$/.test(h)) {
        var L = [0, 2, 4].map(function (i) {
          var v = parseInt(h.slice(i, i + 2), 16) / 255;
          return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        var lum = 0.2126 * L[0] + 0.7152 * L[1] + 0.0722 * L[2];
        hero.style.setProperty('--bh-bg', '#' + h);
        hero.classList.toggle('sts-bhero--light', lum > 0.45);
        hero.setAttribute('data-bh-color', '#' + h);
        applied.color = '#' + h;
        applied.luminance = Math.round(lum * 1000) / 1000;
      }
    }

    if (tx) {
      var t = String(tx).toLowerCase().replace(/[^a-z]/g, '');
      var key = /dot/.test(t) ? 'dots' : /diagonal/.test(t) ? 'diagonal' : /grain/.test(t) ? 'grain'
        : /linen/.test(t) ? 'linen' : /glow/.test(t) ? 'glow' : 'none';
      ['dots', 'diagonal', 'grain', 'linen', 'glow'].forEach(function (k) {
        hero.classList.toggle('sts-bhero--tx-' + k, k === key);
      });
      hero.setAttribute('data-bh-texture', key);
      applied.texture = key;
    }

    if (font && h1) {
      var fk = String(font).toLowerCase().replace(/[^a-z]/g, '');
      var FONTS = {
        playfair: 'Playfair+Display:wght@700', dmserif: 'DM+Serif+Display',
        montserrat: 'Montserrat:wght@800', cormorant: 'Cormorant+Garamond:wght@700', poppins: ''
      };
      var fkey = /playfair/.test(fk) ? 'playfair' : /dmserif|serifdisplay/.test(fk) ? 'dmserif'
        : /montserrat/.test(fk) ? 'montserrat' : /cormorant/.test(fk) ? 'cormorant' : 'poppins';
      Object.keys(FONTS).forEach(function (k) { h1.classList.toggle('sts-bhero__h1--' + k, k === fkey); });
      if (FONTS[fkey]) {
        var l = d.createElement('link');
        l.rel = 'stylesheet';
        l.href = 'https://fonts.googleapis.com/css2?family=' + FONTS[fkey] + '&display=swap&text=' +
          encodeURIComponent(h1.textContent.trim());
        l.setAttribute('data-sts-bfont', 'preview');
        d.head.appendChild(l);
      }
      hero.setAttribute('data-bh-font', fkey);
      applied.font = fkey;
    }

    hero.setAttribute('data-sts-preview', '1');
    if (w.console) w.console.info('[sts-brand] banner preview override', applied);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run);
  else run();
})(window, document);
